module.exports = __webpack_public_path__ + "img/DE03715.00543b38.png";